import { CircularProgress, styled } from '@mui/material'

export const StyledCircularProgress = styled(CircularProgress)(() => ({}))
